import { i18nConfig } from '@/utils/i18n';

export const getInitials = (name: string) => {
  if (!name) return;
  const nameArray = name.split(' ');
  const firstNameInitials = nameArray[0].charAt(0).toUpperCase();
  const lastNameInitials = nameArray[nameArray.length - 1].charAt(0).toUpperCase();

  return firstNameInitials + lastNameInitials;
};

export const clearBodyText = (text: string, clearMessageHistory?: boolean) => {
  const threadIdPattern = /\(Thread-ID: [a-f0-9-]+\)/g;
  const linkPattern = /\(\s*https?:\/\/[^\s]+\s*\)/g;
  const imagePattern = /\[image: [^\]]+\]/g;
  const messageHistoryPattern = /On (\w{3}, \w{3} \d{1,2}, \d{4} at \d{1,2}:\d{2}|\d{1,2} \w{3} \d{4} at \d{1,2}:\d{2}) [^\n]*[\s\S]*/g;

  let cleanedText = text.replace(threadIdPattern, '').replace(linkPattern, '').trim();

  if (clearMessageHistory) {
    cleanedText = cleanedText.replace(imagePattern, '').replace(messageHistoryPattern, '');
  }

  return cleanedText;
};

export const dateFormatter = (d: string, locale: string = 'en', options: Intl.DateTimeFormatOptions = {}) => {
  const date = new Date(d);
  const formatOptions = Object.keys(options).length
    ? options
    : ({ dateStyle: 'long' } as Intl.DateTimeFormatOptions);

  return new Intl.DateTimeFormat(locale, formatOptions).format(date);
};

export const formatDateUS = (date?: string) => {
  const dateTime = new Date(date);
  const options = { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' };

  return dateTime.toLocaleString('en-US', options) + ' at ' + dateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
};

export const dateTimeFormatter = (dateString?: string | Date, locale = 'en') => {
  if (!dateString) return;
  const date = new Date(dateString);
  const now = new Date();

  const timeString = date.toLocaleTimeString(locale, { hour: 'numeric', minute: 'numeric', hour12: true });
  const isToday = now.toDateString() === date.toDateString();

  if (isToday) {
    return `${timeString}, ${i18nConfig.global.t('common.today')}`;
  } else {
    const dayAndMonth = dateFormatter(date.toISOString(), locale, { day: 'numeric', month: 'short' });

    return `${timeString}, ${dayAndMonth}`;
  }
};
